import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "div" ];

  close(event) {
    event.preventDefault();
    this.hide();
  }

  show(event) {
    if (this.divTarget.classList.contains("toast-invisible")) {
      this.divTarget.classList.remove("toast-invisible");
      this.divTarget.lastElementChild.innerText = event.detail;

      setTimeout(() => { this.hide() }, 4000);
    }
  }

  hide() {
    if (!this.divTarget.classList.contains("toast-invisible")) {
      this.divTarget.classList.add("toast-invisible");
    }
  }
}